import React from 'react';
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';

const CellUrl = ({ value, type = 'simple' }) => {
    const { t } = useTranslation();
    return (
        <Box className={"list-element-cell cell-" + type}>
            <a href={value} rel="noreferrer" target='_blank'>{value}</a> 
        </Box>
    )
}

export default CellUrl